import iosDate from './ios/date.png'
import iosDateTime from './ios/datetime-local.png'
import iosDecimalInputmode from './ios/decimal-inputmode.png'
import iosEmail from './ios/email.png'
import iosMonth from './ios/month.png'
import iosNumber from './ios/number.png'
import iosSearch from './ios/search.png'
import iosTel from './ios/tel.png'
import iosText from './ios/text.png'
import iosTime from './ios/time.png'
import iosUrl from './ios/url.png'

import androidDate from './android/date-modal.png'
import androidDateTime from './android/datetime-local-modal.png'
import androidDecimalInputmode from './android/inputmode_decimal.png'
import androidEmail from './android/email.png'
import androidMonth from './android/month-modal.png'
import androidNumber from './android/number.png'
import androidSearch from './android/search.png'
import androidTel from './android/tel.png'
import androidText from './android/text.png'
import androidTime from './android/time-modal.png'
import androidUrl from './android/url.png'

const text = {
  ios: iosText,
  android: androidText,
  alt: 'text keyboard'
}

const search = {
  ios: iosSearch,
  android: androidSearch,
  alt: 'search keyboard'
}

const tel = {
  ios: iosTel,
  android: androidTel,
  alt: 'telephone-optimized keyboard'
}

const email = {
  ios: iosEmail,
  android: androidEmail,
  alt: 'email-optimized keyboard'
}

const url = {
  ios: iosUrl,
  android: androidUrl,
  alt: 'url-optimized keyboard'
}

const number = {
  ios: iosNumber,
  android: androidNumber,
  alt: 'number input-optimized keyboard'
}

const date = {
  ios: iosDate,
  isModal: true,
  android: androidDate,
  alt: 'keyboard (ios) or modal (android) for choosing month, day and year'
}

const time = {
  ios: iosTime,
  isModal: true,
  android: androidTime,
  alt: 'keyboard (ios) or modal (android) for choosing hour, minute, and am/pm'
}

const dateTimeLocal = {
  ios: iosDateTime,
  isModal: true,
  android: androidDateTime,
  alt:
    'keyboard (ios) or modal (android) for choosing month and day as well as hour, minute, and am/pm. Year is selected implicitly.'
}

const month = {
  ios: iosMonth,
  isModal: true,
  android: androidMonth,
  alt: 'keyboard (ios) or modal (android) for choosing month and year'
}

const password = {
  ios: iosText,
  android: androidText,
  alt: 'Text keyboard shown when input has a password type'
}

const decimalInputmode = {
  ios: iosDecimalInputmode,
  android: androidDecimalInputmode,
  alt:
    'Number-focused keyboard, differs from numeric type on ios by being more oriented towards solely inputing numbers'
}

export default {
  type: {
    text,
    search,
    tel,
    url,
    number,
    date,
    time,
    'datetime-local': dateTimeLocal,
    month,
    email,
    password
  },

  inputmode: {
    text,
    search,
    tel,
    url,
    numeric: number,
    decimal: decimalInputmode,
    email
  }
}
